const KEY = 'qr.remember';

/** "Remember me" on the sign-in page: on unless the person turned it off on this browser. */
export function rememberMe(): boolean {
  try {
    return localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
}

export function setRememberMe(on: boolean): void {
  try {
    if (on) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, '0');
  } catch {
    // storage blocked: the choice simply does not stick
  }
}

const MODE_KEY = 'qr.signin.mode';

export type SignInMode = 'code' | 'password';

/** Which way this browser signed in last time, so the page opens on it. */
export function lastSignInMode(): SignInMode {
  try {
    return localStorage.getItem(MODE_KEY) === 'password' ? 'password' : 'code';
  } catch {
    return 'code';
  }
}

export function setLastSignInMode(mode: SignInMode): void {
  try {
    localStorage.setItem(MODE_KEY, mode);
  } catch {
    // storage blocked: the page just opens on the code each time
  }
}
